import getMessage from 'src/background/utils/i18n.utils';
import { CURATIONS_REWARDS_TYPES, OperationsHiveEngine, } from '@interfaces/tokens.interface';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { fetchMoreTokenHistory, loadTokenHistory, } from '@popup/steem/actions/token.actions';
import { TokenHistoryItemComponent } from '@popup/steem/pages/app-container/home/tokens/tokens-history/token-history-item/token-history-item.component';
import { TokenTransactionUtils } from '@popup/steem/utils/token-transaction.utils';
import { Screen } from '@reference-data/screen.enum';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { BackToTopButton } from 'src/common-ui/back-to-top-button/back-to-top-button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import RotatingLogoComponent from 'src/common-ui/rotating-logo/rotating-logo.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const TokensHistory = ({ activeAccountName, currentTokenBalance, tokenHistory, loadTokenHistory, setTitleContainerProperties, isTokenHistoryLoading, shouldLoadMore, fetchMoreTokenHistory, }) => {
    const [displayedTransactions, setDisplayedTransactions] = useState([]);
    const [filterValue, setFilterValue] = useState('');
    const [displayScrollToTop, setDisplayedScrollToTop] = useState(false);
    const walletItemList = useRef(null);
    useEffect(() => {
        loadTokenHistory(activeAccountName, currentTokenBalance.symbol);
        setTitleContainerProperties({
            title: 'popup_html_tokens_history',
            titleParams: [currentTokenBalance.symbol],
            isBackButtonEnabled: true,
        });
    }, []);
    useEffect(() => {
        setDisplayedTransactions(tokenHistory.filter((item) => {
            return ((CURATIONS_REWARDS_TYPES.includes(item.operation) &&
                TokenTransactionUtils.filterCurationReward(item, filterValue)) ||
                (item.operation === OperationsHiveEngine.TOKENS_TRANSFER &&
                    TokenTransactionUtils.filterTransfer(item, filterValue)) ||
                (item.operation === OperationsHiveEngine.TOKEN_STAKE &&
                    TokenTransactionUtils.filterStake(item, filterValue)) ||
                (item.operation === OperationsHiveEngine.MINING_LOTTERY &&
                    TokenTransactionUtils.filterMiningLottery(item, filterValue)) ||
                (item.operation === OperationsHiveEngine.TOKENS_DELEGATE &&
                    TokenTransactionUtils.filterDelegation(item, filterValue)) ||
                item.amount.toLowerCase().includes(filterValue.toLowerCase()) ||
                item.operation.toLowerCase().includes(filterValue.toLowerCase()) ||
                (item.timestamp &&
                    moment(item.timestamp)
                        .format('L')
                        .includes(filterValue.toLowerCase())));
        }));
    }, [tokenHistory, filterValue]);
    const handleScroll = (event) => {
        setDisplayedScrollToTop(event.target.scrollTop !== 0);
    };
    return (React.createElement("div", { "data-testid": `${Screen.TOKENS_HISTORY}-page`, className: "tokens-history" },
        React.createElement(InputComponent, { dataTestId: "input-filter-box", type: InputType.TEXT, placeholder: "popup_html_search", value: filterValue, onChange: setFilterValue }),
        React.createElement("div", { className: "item-list", ref: walletItemList, onScroll: handleScroll },
            displayedTransactions.map((transaction) => (React.createElement(TokenHistoryItemComponent, { dataTestId: `token-history-item-${transaction.symbol}`, key: transaction._id, transaction: transaction }))),
            displayedTransactions.length === 0 && !isTokenHistoryLoading && (React.createElement("div", { className: "empty-history-panel" },
                React.createElement(SVGIcon, { icon: SVGIcons.MESSAGE_ERROR }),
                React.createElement("div", { className: "text" },
                    React.createElement("div", null, getMessage('popup_html_transaction_list_is_empty')),
                    React.createElement("div", null, getMessage('popup_html_transaction_list_is_empty_try_clear_filter'))))),
            shouldLoadMore && !isTokenHistoryLoading && (React.createElement("div", { className: "load-more-panel", onClick: () => {
                    fetchMoreTokenHistory(activeAccountName, currentTokenBalance.symbol);
                } },
                React.createElement("span", { className: "label" }, getMessage('popup_html_load_more')),
                React.createElement(SVGIcon, { icon: SVGIcons.GLOBAL_ADD_CIRCLE }))),
            isTokenHistoryLoading && (React.createElement("div", { className: "rotating-logo-container" },
                React.createElement(RotatingLogoComponent, null)))),
        displayScrollToTop && React.createElement(BackToTopButton, { element: walletItemList })));
};
const mapStateToProps = (state) => {
    var _a, _b;
    return {
        activeAccountName: (_a = state.steem.activeAccount) === null || _a === void 0 ? void 0 : _a.name,
        userTokens: state.steem.userTokens,
        currentTokenBalance: (_b = state.navigation.params) === null || _b === void 0 ? void 0 : _b.tokenBalance,
        tokenHistory: state.steem.tokenHistory.list,
        isTokenHistoryLoading: state.steem.tokenHistory.loading,
        shouldLoadMore: state.steem.tokenHistory.shouldLoadMore,
    };
};
const connector = connect(mapStateToProps, {
    loadTokenHistory,
    setTitleContainerProperties,
    fetchMoreTokenHistory,
});
export const TokensHistoryComponent = connector(TokensHistory);
